import React, { useRef, useEffect, useState, useCallback } from 'react';
import styles from './FJTimepiece.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import PropTypes from 'prop-types';
import FJEvent from '../../../store/FJEvent.js';
import FJLimitedCouponStore from '../../../store/FJLimitedCouponStore.js';
import PointIcon from '../../../assets/svg/point.svg?react';

const Item = props => {
    const { text, unit } = props;
    return (
        <div className={styles.item_box}>
            <div className={styles.title1}>{text}</div>
            <div className={styles.title2}>{unit}</div>
        </div>
    );
};

const FJTimepiece = props => {
    const { time = 0 } = props;
    const [milliseconds, setMilliseconds] = useState(time);

    useEffect(() => {
        return FJEvent.subscribe('UPDATE_COUNTDOWN', remainingTime => {
            setMilliseconds(remainingTime);
        });
    }, []);

    // 启动计时器
    useEffect(() => {
        if (time > 0) {
            FJLimitedCouponStore.startCountdown(time);
        }
    }, [time]);

    // 将毫秒转换为小时、分钟、秒
    // const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.max(0, Math.floor((milliseconds % 3600000) / 60000));
    const seconds = Math.max(0, Math.floor((milliseconds % 60000) / 1000));

    return (
        <div className={styles.container}>
            <Item text={minutes.toString().padStart(2, '0')} unit={FJLocalStore._('minutes')} />
            <PointIcon />
            <Item text={seconds.toString().padStart(2, '0')} unit={FJLocalStore._('seconds')} />
        </div>
    );
};

FJTimepiece.propTypes = {
    time: PropTypes.number,
};

Item.propTypes = {
    text: PropTypes.string,
    unit: PropTypes.string,
};

export default FJTimepiece;
